import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages} from "../helpers/lazy-load";

let productsSliderBlocks = $('.js-newest-products-block')

if (productsSliderBlocks.length){

    productsSliderBlocks.each(function (){
        let block = $(this)
        let prevButton = $(this).find('.swiper-button-prev')
        let nextButton = $(this).find('.swiper-button-next')

        let productsSwiper = new Swiper(block.find('.js-newest-products-slider')[0], {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            loop: true,
            slidesPerView: 2,
            navigation: {
                nextEl: nextButton[0],
                prevEl: prevButton[0],
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            on: {
                slideChange: function (slider) {
                    if (slider.realIndex > 0) {
                        loadBlockLazyImages(productsSliderBlocks)
                    }
                },
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                900: {
                    slidesPerView: 4,
                }
            },
        })

    })
}
